<template>
  <el-tabs v-model="tabActive" @tab-click="fetch">
    <el-tab-pane :label="$t('latest-articles')" name="articles">
      <div v-if="articleList.length">
        <div
          v-for="article in articleList"
          :key="article.id"
          class="mb--xl">
          <dara-article-card :article="article" />
        </div>
      </div>
      <div v-else>
        <dara-p class="opacity--50 my--md">( {{ $t('no-articles') }} )</dara-p>
      </div>
      <div v-if="articleList.length" class="d-flex justify-content-center">
        <dara-pagination
          :page.sync="pagination.page"
          :total="pagination.total"
          :page-size="pagination.limit"
          @current-change="fetch" />
      </div>
    </el-tab-pane>

    <el-tab-pane :label="$t('latest-tracks')" name="tracks">
      <div v-if="trackList.length">
        <div
          v-for="track in trackList"
          :key="track.id"
          class="mb-4">
          <dara-track-card :track="track" />
        </div>
      </div>
      <div v-else>
        <dara-p class="opacity--50 my--md">( {{ $t('no-tracks') }} )</dara-p>
      </div>
      <div v-if="trackList.length" class="d-flex justify-content-center">
        <dara-pagination
          :page.sync="pagination.page"
          :total="pagination.total"
          :page-size="pagination.limit"
          @current-change="fetch" />
      </div>
    </el-tab-pane>

    <el-tab-pane :label="$t('latest-questions')" name="questions">
      <div v-if="questionList.length">
        <div
          v-for="question in questionList"
          :key="question.id"
          class="mb-4">
          <dara-question-card :question="question" />
        </div>
      </div>
      <div v-else>
        <dara-p class="opacity--50 my--md">( {{ $t('no-questions') }} )</dara-p>
      </div>
      <div v-if="questionList.length" class="d-flex justify-content-center">
        <dara-pagination
          :page.sync="pagination.page"
          :total="pagination.total"
          :page-size="pagination.limit"
          @current-change="fetch" />
      </div>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import { fetchArticles } from '@/modules/article/article.service';
import { fetchTracks } from '@/modules/track/track.service';
import { fetchQuestions } from '@/modules/question/question.service';

import DaraArticleCard from '@/modules/article/components/ArticleCard.vue';
import DaraTrackCard from '@/modules/track/components/TrackCard.vue';
import DaraQuestionCard from '@/modules/question/components/QuestionCard.vue';

export default {
  name: 'DaraHomeTabs',
  components: {
    DaraArticleCard,
    DaraTrackCard,
    DaraQuestionCard,
  },
  data() {
    return {
      tabActive: 'articles',
      articleList: [],
      trackList: [],
      questionList: [],
      pagination: {
        page: 1,
        limit: 5,
      },
    };
  },
  mounted() {
    this.fetch();
  },
  methods: {
    fetch() {
      if (this.tabActive === 'articles') {
        this.fetchArticles();
      } else if (this.tabActive === 'tracks') {
        this.fetchTracks();
      } else {
        this.fetchQuestions();
      }
    },
    fetchArticles() {
      fetchArticles(this.pagination)
        .then(data => {
          this.articleList = data.data;
          Object.assign(this.pagination, data.pagination);
        })
        .catch(() => {
          this.articleList = [];
        });
    },
    fetchTracks() {
      fetchTracks(this.pagination)
        .then(data => {
          this.trackList = data.data;
          Object.assign(this.pagination, data.pagination);
        })
        .catch(() => {
          this.trackList = [];
        });
    },
    fetchQuestions() {
      fetchQuestions(this.pagination)
        .then(data => {
          this.questionList = data.data;
          Object.assign(this.pagination, data.pagination);
        })
        .catch(() => {
          this.questionList = [];
        });
    },
  },
};
</script>
